import { transport } from 'config/transport';

export function callApiGetAbsences(params) {
    return transport.get(`/mamnon/absences`, { params });
}
